class GenericInterceptor {

  /* ngInject */
  constructor($q, AlertService, $injector, LoaderService) {
    this.$q = $q;
    this.AlertService = AlertService;
    this.$injector = $injector;
    this.LoaderService = LoaderService;
  }

  request = (config) => {
    var self = this;
    self.LoaderService.start();
    return config;
  };

  response = (response) => {
    var self = this;
    self.$http = self.$http || self.$injector.get('$http');
    if(self.$http.pendingRequests.length < 1) {
      self.LoaderService.stop();
    }
    return response;
  };

  responseError = (rejection) => {

    var self = this;
    self.$http = self.$http || self.$injector.get('$http');
    if(self.$http.pendingRequests.length < 1) {
      self.LoaderService.stop();
    }

    if (rejection.status === 404) {
      // Return a new promise
      return this.AlertService.error('The resource was not found.');
    }

    /* If not a 404, do nothing with this error.
     * This is necessary to make a `responseError`
     * interceptor a no-op. */
    return this.$q.reject(rejection);
  }
}

GenericInterceptor.$inject = ['$q', 'AlertService', '$injector', 'LoaderService'];
export default GenericInterceptor;
